import {Request} from './Request';
import {MessageTriggerType} from '../enums/message.trigger.enum';

export class TriggerMessageRequest implements Request {
    chargePointSelectList: string[];
    private connectorId: string;
    private triggerMessage: MessageTriggerType;

    constructor(chargePointSelectList: string[], connectorId?: string, triggerMessage?: MessageTriggerType) {
        this.chargePointSelectList = chargePointSelectList;
        this.connectorId = connectorId;
        this.triggerMessage = triggerMessage;
    }

    public toString = (): string => {
        return `TriggerMessageRequest (chargePointSelectList: ${this.chargePointSelectList},
        connectorId: ${this.connectorId}, triggerMessage: ${this.triggerMessage})`;
    }

    get connector_id(): string {
        return this.connectorId;
    }

    set connector_id(value: string) {
        this.connectorId = value;
    }

    get trigger_message(): MessageTriggerType {
        return this.triggerMessage;
    }

    set trigger_message(value: MessageTriggerType) {
        this.triggerMessage = value;
    }
}
